import React, { useState, useEffect, useRef, useId } from 'react';
import RichText from '/react4xp/components/RichText'; 
import { CaretUp, CaretDown } from '../Svg/Others/Icons';
import IconWrapper from '/react4xp/components/Icon';

interface FactBoxProps {
    content: string;
    bgColor: 'insights' | 'news' | 'success-stories';
    articleType: 'news' | 'insights' | 'success-stories';
}

export default function FactBox({ content, bgColor, articleType }: FactBoxProps) {
    const [isOpen, setIsOpen] = useState(false);
    const factBoxContentRef = useRef<HTMLDivElement>(null);

    // unique per instance, the accordion macro can render several on one page
    const instanceId = useId();
    const buttonId = `${instanceId}-button`;
    const panelId = `${instanceId}-panel`;

    const handleToggle = () => {
        setIsOpen(prevState => !prevState);
    };

    useEffect(() => {
        const factBoxContent = factBoxContentRef.current;

        if (factBoxContent) {
            factBoxContent.style.setProperty('--fade-color', bgColor);
        }
    }, [bgColor]);

    return (
        <div
            className={`fact-box ${isOpen ? 'fact-box--open' : ''} fact-box--${articleType}`}
        >
            <div className="fact-box__item">
                {/* a disclosure, not an accordion: the panel is a teaser that stays
                    partly readable while collapsed, so it is never hidden and carries
                    no role="region" — three boxes all named "See more" by their
                    trigger would be indistinguishable landmarks */}
                <div
                    id={panelId}
                    className={`fact-box__content${isOpen ? '--open' : ''} rich-text`}
                    tabIndex={-1}
                    ref={factBoxContentRef}
                >
                    <div className="fact-box__text rich-text">
                        <RichText content={content} />
                    </div>
                </div>
                <button
                    type="button"
                    id={buttonId}
                    className="fact-box__btn"
                    aria-expanded={isOpen}
                    aria-controls={panelId}
                    onClick={handleToggle}
                >
                    {isOpen ? 'See less' : 'See more'}
                    <IconWrapper
                        IconComponent={isOpen ? CaretUp : CaretDown}
                        iconColor="primary"
                        iconSide="right"
                        iconSize="sm"
                    />
                </button>
            </div>
        </div>
    );
}
